import React from "react";
import './CalendarAccordion.scss'
import { IoAddCircleOutline, IoRemoveCircleOutline } from "react-icons/io5";

const CalendarAccordion = ({
  calendarEvent,
  isActiveSection,
  setActiveIndex,
  sectionIndex,
}) => {
  const toggleSection = () => {
    const nextIndex = isActiveSection ? null : sectionIndex;
    setActiveIndex(nextIndex);
  };
  return (
    <div
      id="calendar-accordion"
      className={`${
        isActiveSection
          ? "calendar-accordion-item-open"
          : "calendar-accordion-item-close"
      }`}
    >
      <div className="calendar-accordion-item-title" onClick={toggleSection}>
        <p>{calendarEvent.title}</p>
        {isActiveSection ? <IoRemoveCircleOutline /> : <IoAddCircleOutline />}
      </div>
      <div className="calendar-accordion-details">
        <p className="activities-title">Activities</p>
        <table className="activities-list">
          <tbody>
            {calendarEvent.activities.map((activity, index) => (
              <tr className="activity" key={index}>
                <td className="activity-name">
                  {activity.names.map((name, index)=>(
                   <p style={{marginBottom:"5px"}} key={index}>{name}</p>
                  ))}
                </td>
                <td className="activity-date">{activity.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="calendar-bottom">{calendarEvent?.important_notice}</div>
      </div>
    </div>
  );
};

export default CalendarAccordion;
